<template>
  <div class="details" v-if="lottery">
    <div class="kaijiangjilubox">
      <h3 class="kaijiangjilu">开奖记录</h3>
      <selectedDate @changepageindex="changepageindex()" />
    </div>
    <div class="tablebox">
      <table cellpadding="0" cellspacing="0" border="0" v-if="hisLotteryList.length>0">
        <tr>
          <td width="162">期数</td>
          <td>正码</td>
          <td width="112">特码</td>
          <td>特码单双</td>
          <td>特码大小</td>
          <td>总和单双</td>
          <td>总和大小</td>
        </tr>
        <tr v-for="(item,index) in hisLotteryList" :key="item.periodsId">
          <td style="fontSize:13px;font-weight:400;">{{item.periodsNumber}}</td>
          <td>
            <ul class="table-ul" v-show="flag == 'num'">
              <li class="table-li">
                <span class="ballspan" :class="'sebo-'+findNumbColor(lotteryNum[index][0])">{{lotteryNum[index][0]}}</span>
                <span>{{findNumbAnimal(lotteryNum[index][0],getAnimalList(item.periodsNumber))}}</span>
              </li>
              <li class="table-li">
                <span class="ballspan" :class="'sebo-'+findNumbColor(lotteryNum[index][1])">{{lotteryNum[index][1]}}</span>
                <span>{{findNumbAnimal(lotteryNum[index][1],getAnimalList(item.periodsNumber))}}</span>
              </li>
              <li class="table-li">
                <span class="ballspan" :class="'sebo-'+findNumbColor(lotteryNum[index][2])">{{lotteryNum[index][2]}}</span>
                <span>{{findNumbAnimal(lotteryNum[index][2],getAnimalList(item.periodsNumber))}}</span>
              </li>
              <li class="table-li">
                <span class="ballspan" :class="'sebo-'+findNumbColor(lotteryNum[index][3])">{{lotteryNum[index][3]}}</span>
                <span>{{findNumbAnimal(lotteryNum[index][3],getAnimalList(item.periodsNumber))}}</span>
              </li>
              <li class="table-li">
                <span class="ballspan" :class="'sebo-'+findNumbColor(lotteryNum[index][4])">{{lotteryNum[index][4]}}</span>
                <span>{{findNumbAnimal(lotteryNum[index][4],getAnimalList(item.periodsNumber))}}</span>
              </li>
              <li class="table-li">
                <span class="ballspan" :class="'sebo-'+findNumbColor(lotteryNum[index][5])">{{lotteryNum[index][5]}}</span>
                <span>{{findNumbAnimal(lotteryNum[index][5],getAnimalList(item.periodsNumber))}}</span>
              </li>
            </ul>
          </td>
          <td style="fontSize:13px;font-weight:600;" width="77">
            <ul class="table-ul">
              <li class="table-li">
                <span class="ballspan" :class="'bgc-'+findNumbColor(lotteryNum[index][6])">{{lotteryNum[index][6]}}</span>
                <span>{{findNumbAnimal(lotteryNum[index][6],getAnimalList(item.periodsNumber))}}</span>
              </li>
            </ul>
          </td>
          <td width="99">{{(lotteryNum[index][6] % 2 == 0) ? '双' : '单'}}</td>
          <td width="99">{{lotteryNum[index][6] >= 25 ? lotteryNum[index][6] == 49 ? '和' : '大' : '小'}}</td>
          <td width="99">{{(lhcAddAll[index][0] % 2 == 0) ? '双' : '单'}}</td>
          <td width="99">{{lhcAddAll[index][0] > 174 ? '大' : '小'}}</td>
        </tr>
      </table>
      <h2 v-else class="zanwu">暂无开奖号码</h2>
      <div class="setpage">
        <el-pagination
          :page-size="50"
          :pager-count="11"
          layout="prev, pager, next"
          :total="totalCount"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import mix from "~/mixins/lotterydetails.mixins.vue";
import lhcMixins from "~/mixins/lhc.mixins";

export default {
  mixins: [mix,lhcMixins],
  data() {
    return {
      flag : 'num',
    };
  },
  methods: {
    changeflag(f){
      this.flag = f;
    },
    getAnimalList(periodsNumber) {
      return this.getCurrYearAnimal(periodsNumber.slice(0, 4));
    },
  },
  computed: {
    // 总和(arr[arr])
    lhcAddAll(){
      return this.$store.state.lottery.lhcAddAll
    },
  },
  created() {}
};
</script>

<style lang="less" scoped>
.zanwu{
  font-weight: 400;
  line-height: 26px;
  font-size: 13px;
  text-align: center;
}
.details {
  margin-top: 20px;
  width: 100%;
  background-color: #fff;
  .kaijiangjilubox{
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #e7e7e7;
    .kaijiangjilu {
      padding: 10px 20px;
      line-height: 32px;
      font-size: 18px;
      font-weight: 500;
      color: #555;
      display: inline-block;
    }
  }
  .tablebox {
    padding-top: 20px;
    margin-left: 20px;
    padding-bottom: 30px;
    width: 1160px;
    .btntr{
      display: flex;
      justify-content: center;
      .btn{
        background-color: #b9b9b9;
        color: #fff;
        width: 80px;
        height: 26px;
        line-height: 26px;
        margin: 7px 5px;
        font-size: 12px;
        border-radius: 4px;
        cursor: pointer;
      }
      .selected{
        background-color: #50515f;
      }
    }
    
    table {
      width: 100%;
      text-align: center;
      font-size: 16px;
      font-weight: 300;
      background: #e7e7e7;
      border-top: solid 1px rgb(212, 212, 212);
      border-left: solid 1px rgb(212, 212, 212);
      tr {
        height: 42px;
        td {
          border-right: solid 1px rgb(212, 212, 212);
          border-bottom: solid 1px rgb(212, 212, 212);
        }
        &:nth-child(2n) {
          background-color: #fff;
        }
        .redtd{
          font-size:14px;
          font-weight:600;
          color: #f12d35;
        }
        .bluetd{
          font-size:14px;
          font-weight:600;
          color: #184dd5;
        }
      }
    }
    .table-ul{
      display: flex;
      justify-content: center;
      height: 32px;
      .table-li{
        margin: 3px 2px;
        line-height: 30px;
        width: 72px;
        height: 30px;
        font-weight: 500;
        font-size: 16px;
        span{
          display: inline-block;
          width: 30px;
          height: 30px;
        }
        .ballspan{
          border-radius: 15px;
        }
        .sebo-red{
          box-shadow: 0 0px 1px 1px #ff4545, inset 0 0px 1px 1px #ff4545;
        }
        .sebo-blue{
          box-shadow: 0 0px 1px 1px #4ea9ff, inset 0 0px 1px 1px #4ea9ff;
        }
        .sebo-green{
          box-shadow: 0 0px 1px 1px #54ecbf, inset 0 0px 1px 1px #54ecbf;
        }
        .bgc-red{
          background-color: #ff4545;
          color: #fff;
        }
        .bgc-blue{
          background-color: #4ea9ff;
          color: #fff;
        }
        .bgc-green{
          background-color: #54ecbf;
          color: #fff;
        }
      }
      .table-bs{
        line-height: 36px;
        width: 36px;
        height: 36px;
        margin: 0 2px;
        .bs-cheng{
          background-color: #f9982e;
          border-radius: 18px;
          font-size: 18px;
          color: #fff;
        }
        .bs-hui{
          background-color: #7f8ab0;
          border-radius: 18px;
          font-size: 18px;
          color: #fff;
        }
        .bs-he{
          background-color: #3c9bd1;
          border-radius: 18px;
          font-size: 18px;
          color: #fff;
        }
      }
    }
    .setpage{
      width: 100%;
      margin-top: 28px;
      .el-pagination{
        text-align: center;
      }
    }
  }
}
</style>